import SandboxEditor from "./sandbox_editor.js";

window.web = { "SandboxEditor": SandboxEditor };
